import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button/Button';
import FormGroup from 'components/FormGroup/FormGroup';
import FormItem from 'components/FormItem/FormItem';
import Input from 'components/Input/Input';

import { validateInn, validatePhone, validateReqiured } from 'utils/validate';

import styles from '../../terminal.scss';

function ConnectStep(props) {
    const { terminalSettings } = props;

    const [fields, setFields] = React.useState({
        inn: {
            value: terminalSettings.inn,
            validations: [validateReqiured, validateInn],
        },
        owner_phone: {
            value: terminalSettings.owner_phone,
            validations: [validateReqiured, validatePhone],
        },
        taxation_type: {
            value: 'osn',
            validations: [validateReqiured],
        },
        ffd: {
            value: '1.2',
            validations: [validateReqiured],
        },
        vat: {
            value: 'none',
            validations: [validateReqiured],
        },
        return_url: {
            value: 'https://dispurse.app/done',
            validations: [validateReqiured],
        },
    });

    function validateField(fieldName, value) {
        const field = fields[fieldName];
        const validations = field.validations;

        const errors = validations.map((validation) => validation(value)).filter((error) => Boolean(error));

        return errors[0];
    }

    function handleTextFieldChange(e) {
        const field = e.target.name;
        const value = e.target.value;

        const error = validateField(field, value);

        setFields((prev) => ({ ...prev, [field]: { ...prev[field], value, error } }));
    }

    function prepareSettings() {
        const settings = {};

        for (const field in fields) {
            settings[field] = fields[field].value;
        }

        return settings;
    }

    function validateForm() {
        let errorsCount = 0;

        for (const field in fields) {
            const error = validateField(field, fields[field].value);

            if (error) {
                errorsCount++;
            }

            setFields((prev) => ({ ...prev, [field]: { ...prev[field], error } }));
        }

        return errorsCount;
    }

    function handleCompleteClick() {
        const errors = validateForm();

        if (errors > 0) {
            return false;
        }

        const settings = prepareSettings();
        settings.isYookassa = true;

        if (props.onTerminalSave) {
            /**
             * The second argument is Yookassa flag.
             */
            props.onTerminalSave(settings);
        }
    }

    React.useEffect(() => {
        const { inn, owner_phone } = props.terminalSettings;

        setFields((prevFields) => ({
            ...prevFields,

            inn: { ...prevFields.inn, value: inn },
            owner_phone: { ...prevFields.owner_phone, value: owner_phone },
        }));
    }, [props.terminalSettings, setFields]);

    return (
        <FormGroup>
            <FormItem>
                <h2 className={styles.yookassaStepTitle}>Шаг 1 из 2. Контактные данные</h2>
                <p className={styles.note}>Укажите телефон и ИНН, которые будут связаны с вашим платёжным аккаунтом.</p>
            </FormItem>
            <FormItem label={'Телефон'} required={true} error={fields.owner_phone.error}>
                <Input
                    type="text"
                    name="owner_phone"
                    value={fields.owner_phone.value}
                    onChange={handleTextFieldChange}
                />
            </FormItem>

            <FormItem label={'ИНН'} required={true} error={fields.inn.error}>
                <Input type="text" name="inn" value={fields.inn.value} onChange={handleTextFieldChange} />
            </FormItem>

            <FormItem>
                <Button
                    fill={true}
                    isLoading={props.isLoading}
                    onClick={handleCompleteClick}
                    text="Создать терминал"
                ></Button>
            </FormItem>
        </FormGroup>
    );
}

ConnectStep.propTypes = {
    onTerminalSave: PropTypes.func,
    isLoading: PropTypes.bool,
    terminalSettings: PropTypes.shape({
        id: PropTypes.number,
        company_id: PropTypes.number,
        inn: PropTypes.string,
        owner_phone: PropTypes.string,
        registration_status: PropTypes.oneOf(['PENDING', 'MANUAL_BOARDING']),
    }),
};

export default ConnectStep;
